//@ts-check
import { createSlice } from "@reduxjs/toolkit";
import { CompanyAdmin } from "apps/company/common/dataTypes";

type InitialState = {
  companyAdmin: CompanyAdmin;
};

const initialState: InitialState = {
  companyAdmin: {
    id: "",
    firstName: "",
    lastName: "",
    fullName: "",
    companyName: "",
    companyType: "",
    companyId: "",
  },
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setCompanyAdmin: (
      state,
      action: {
        type: string;
        payload: CompanyAdmin;
      }
    ) => {
      state.companyAdmin = action.payload;
    },
  },
});

export const { setCompanyAdmin } = globalSlice.actions;

export default globalSlice.reducer;
